<template>
	<div class="page">
		<div class="pageTitleBox">
			<div class="boxNameL">
				会员充值
			</div>
		</div>
		<el-row style="padding:30px 40px 10px;background-color: #ffffff;line-height: 40px;" >
			<el-col :span="6">
				<span>充值活动：</span>
				<span>
					<el-select class="select" v-model="curActivity" @change="changeActivity" placeholder="请选择">
						<el-option popper-class="select" v-for="(item,index) in activityList" :key="'activity'+index" :label="item.activity_name"
						:value="index">
						</el-option>
					</el-select>
				</span>
			</el-col>
			<el-col :span="6" >
				<span>顾客：</span>
				<span >
					<remoteVipSelect style="width:220px;display: inline-block;" :propsVipInfo="propsVipInfo" @getCurVipItem="getCurVipItem"></remoteVipSelect>
					<span v-if="userInfo._id&&userInfo.club_card. surplus_day===3&&userInfo.club_card.old_interest===true" style="color:#E6A23C"> (老)</span>
				</span>
			</el-col>
			<el-col :span="6" v-if="curActivity!==''&&activityList[curActivity].give_services.length>0">
				<span>宠物：</span>
				<span>
					<remotePetSelect style="width:250px;display: inline-block;" :propsPetList="propsPetList" @getCurPetItem="getCurPetItem"></remotePetSelect>
				</span>
			</el-col>
			<el-col :span="6">
				<span>销售人员：</span>
				<span>
					<el-select class="select" multiple v-model="curStaff" filterable placeholder="请选择">
						<el-option popper-class="select" v-for="(item,index) in staffList" :key="item._id" :label="item.basic_info.nick_name"
						:value="index">
						</el-option>
					</el-select>
				</span>
			</el-col>
		</el-row>
		<el-row style="padding:20px 40px 0px;background-color: #ffffff;line-height: 40px;">
			<el-col :span="6">
				<span style="padding-left:32px;vertical-align: top;">备注：</span>
				<span>
					<el-input type="textarea" class="select" style="width:212px;" v-model="remark"></el-input>
				</span>
			</el-col>
		</el-row>
		<div style="padding:40px;" v-if="curActivity!==''&&activityList[curActivity].give_services.length>0">
			<div style="padding-bottom:20px;">赠送的服务</div>
			<div style="display: flex;padding-left:20px;"  v-for="(item,index) in activityList[curActivity].give_services" :key="index">
				<div style="width:300px">{{item.service_name}}</div>
				<div style="width:200px">￥{{item.price}}</div>
				<div style="width:200px">{{item.consume_count}}次</div>
				<div style="width:200px">{{item.days}}天</div>
			</div>
		</div>
		<div style="padding:40px;" v-if="tableData.length>0">
			<div style="padding-bottom:20px;">赠送的商品</div>
			<div style="padding:10px 20px;">
				<el-row>
					<el-col :span="5">
						<el-input v-model="scanningCodeInput" @keyup.enter.native="clickScanningCodeInput" placeholder="请输入商品条码">
							<template slot="append">
								<el-button type="danger" icon="el-icon-search" @click="clickScanningCodeInput"></el-button>
							</template>
						</el-input>
					</el-col>
				</el-row>
				<el-table :data="tableData" max-height='300' style="width: 100%;margin-bottom: 20px;" row-key="tableKey"
				:tree-props="{children: 'goodsList', hasChildren: 'hasChildren'}">
					<el-table-column prop="goodsName" label="名称" width="350">
					</el-table-column>
					<el-table-column prop="customCode" label="条码" width="250">
						<template slot-scope="scope">
							{{scope.row.goodsList?'':scope.row.customCode}}
						</template>
					</el-table-column>
					<el-table-column prop="skuValue" label="规格">
					</el-table-column>
					<el-table-column prop="num" label="数量" width="100">
					</el-table-column>
					<el-table-column label="操作" width="120">
						<template slot-scope="scope">
							<div>
								<el-button 
								v-if="!scope.row.goodsList"
								@click="delGoods(scope.row)" type="danger"
								size="small">
									删除<!-- (单商品) -->
								</el-button>
							</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
		<div style="text-align: center;padding:30px">
			<!-- <el-button style="margin-right: 50px;" @click="submit('cancel')">取消</el-button> -->
			<el-button type="primary" @click="submit">确定</el-button>
		</div>
		<!-- 结算弹窗 -->
		<div>
			<dialogSettlement v-if="dialogSettlementState" :type="'recharge'" :orderId="order._id" @submit="dialogSettlementSubmit"></dialogSettlement>
		</div>
	</div>
</template>
<script>
	import dialogSettlement from "../../../components/dialog_settlement.vue"
	// import joinActivity from "../../../../components/joinActivity.vue"
	import remoteVipSelect from "../../../components/remoteVipSelect.vue"
	import remotePetSelect from "../../../components/remotePetSelect.vue"
	import del from "../../../util/del.js"
	export default {
		components:{dialogSettlement,remoteVipSelect,remotePetSelect},
		data(){
			return{
				// 充值活动
				curActivity:'',
				activityList:[],
				// 会员
				userInfo:{},
				petInfo:{},
				propsVipInfo:{},
				propsPetList:[],
				// 销售人员
				curStaff: [], 
				staffList: [],
				// 备注
				remark:'',
				// 商品
				scanningCodeInput:'',
				tableData:[],
				o:null,
				// 结算
				dialogSettlementState:false,
				order:{},
			}
		},
		mounted(){
			this.$http.get('/api/Activity/GetRecharge', {}).then(res => {
				if (res.code == 0) {
					this.activityList = res.data;
				}
			})
			this.$http.get('/api/Staff/List', {
				"keyword": '', //关键字
				"pageIndex": 1,
				"pageSize": 1000,
			}).then(res => {
				if (res.code == 0) {
					this.staffList = res.data.data;
				}
			})
			this.o = new del();
		},
		methods: {
			// 重置
			reset(){
				this.curActivity = '';
				this.userInfo = {};
				this.petInfo = {};
				this.propsVipInfo = {};
				this.propsPetList = [];
				this.curStaff = [];
				this.remark = '';
				this.o = null;
				this.order = {};
			},
			// 活动
			changeActivity() {
				this.userInfo={}
				this.petInfo={}
				this.propsVipInfo={}
				this.propsPetList=[]
				if(this.activityList[this.curActivity].give_goods.length>0){
					let arr = []
					for(let i=0;i<this.activityList[this.curActivity].give_goods.length;i++){
						let item = {
							tableKey: 'tableKey'+Math.random(),
							goodsId:this.activityList[this.curActivity].give_goods[i].goods_id,
							goodsName:this.activityList[this.curActivity].give_goods[i].goods_name,
							goodsType:1,
							skus:this.activityList[this.curActivity].give_goods[i].skus,
							skuValue:this.activityList[this.curActivity].give_goods[i].sku_value,
							price:this.activityList[this.curActivity].give_goods[i].price,
							num:this.activityList[this.curActivity].give_goods[i].goods_count,
							goodsList:[],
						}
						item.checkGoods = JSON.parse(JSON.stringify(item));
						arr.push(item)
					}
					this.o.init(arr)
					this.tableData = this.o.arr;
				}else{
					this.o.init([])
					this.tableData = [];
				}
			},
			// 会员
			getCurVipItem(item){
				console.log(item,'选中的顾客');
				if(item){
					this.propsPetList = item;
					this.userInfo = item;
				}else{
					this.propsPetList = [];
					this.userInfo = {};
				}
			},
			getCurPetItem(item){
				console.log(item,'选中的宠物');
				if(item){
					this.propsVipInfo=item;
					this.petInfo=item;
				}else{
					this.propsVipInfo={};
					this.petInfo={};
				}
			},
			// 商品
			clickScanningCodeInput() {
				this.getScanData(this.scanningCodeInput);
			},
			getScanData(code) {
				this.scanningCodeInput=''
				code = (code).toString().trim();
				this.o.searchGoods(code).then(()=>{
					let addState = this.o.addTwoGoods(['xianliang']);
					if(addState===true){
						console.log('添加成功')
					}
					console.log(this.o.arr)
					this.tableData = this.o.arr;
				})
			},
			delGoods(row) {
				let posi = this.o.searchDel(row.customCode);
				this.$confirm('确定要删除?', '警告', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.o.delTwo(posi)
					this.tableData = this.o.arr;
				})
			},
			// 提交
			submit() {
				if (!this.activityList[this.curActivity]) {
					this.$message({
						message: '请选择充值活动',
						type: 'error'
					});
					return;
				}
				if (!this.userInfo._id) {
					this.$message({
						message: '请选择顾客',
						type: 'error'
					});
					return;
				}
				if (this.curStaff.length == 0) {
					this.$message({
						message: '请选择销售人员',
						type: 'error'
					});
					return;
				}
				let pets_info = {};
				if (this.activityList[this.curActivity].give_services.length > 0) { // 送服务选宠物
					if (!this.petInfo.pet_id) {
						this.$message({
							message: '请选择宠物',
							type: 'error'
						});
						return;
					} else {
						pets_info = {
							pets_id:this.petInfo.pet_id,
							pets_name:this.petInfo.pet_name,
						}
					}
				}
				let order_item_list = [];
				if (this.activityList[this.curActivity].give_goods.length > 0) { // 送商品
					if (this.tableData.length == 0) {
						this.$message({
							message: '请录入赠送的商品',
							type: 'error'
						});
						return;
					} else {
						let check = this.o.checkGoods();
						console.log(check)
						for(let i=0;i<check.length;i++){
							if(JSON.stringify(check[i].checkObj)!==JSON.stringify(check[i].inputObj)){
								this.$message({
									message: '录入的商品数量有误',
									type: 'error'
								});
								return;
							}
						}
						let table2 = [];
						for(let i=0;i<this.tableData.length;i++){
							let one = {
								"goods_id": this.tableData[i].goodsId,
								"goods_name": this.tableData[i].goodsName,
								"goods_type": this.tableData[i].goodsType,
								"skus": this.tableData[i].skus,
								"sku_value": this.tableData[i].skuValue,
								"skuValue": this.tableData[i].skuValue,
								"unit": '',
								model:this.tableData[i].skuValue,
								"original_price": this.tableData[i].price,
								"price": this.tableData[i].price,
								"num": this.tableData[i].num,
								"activityId": this.activityList[this.curActivity].activity_id,
								"activityName": this.activityList[this.curActivity].activity_name,
								"totalMoney": 0,
								"goodsUsage": 1,
								"goodsDosage": 1,
								"order_item_goods_list": [],
								"remark": ''
							}
							for(let a=0;a<this.tableData[i].goodsList.length;a++){
								let two = {
									"goods_id": this.tableData[i].goodsList[a].goodsId,
									"goods_name": this.tableData[i].goodsList[a].goodsName,
									"custom_code": this.tableData[i].goodsList[a].customCode,
									"specificationPrice": 0,
									"price": this.tableData[i].goodsList[a].price,
									"skus": this.tableData[i].goodsList[a].skus,
									"skuValue": this.tableData[i].goodsList[a].skuValue,
									"model": this.tableData[i].goodsList[a].skus_type,
									"unit": this.tableData[i].goodsList[a].unit,
									"validity_stop_date": this.tableData[i].goodsList[a].validityStopDate.substr(0,10)
								}
								one.order_item_goods_list.push(two)
							}
							table2.push(one)
						}
						order_item_list = table2
					}
				}
				let sales_list = []
				for (let i = 0; i < this.curStaff.length; i++) {
					sales_list.push({
						sales_id: this.staffList[this.curStaff[i]]._id,
						sales_name: this.staffList[this.curStaff[i]].basic_info.nick_name,
					})
				}
				let params = {
					"activity_id": this.activityList[this.curActivity].activity_id,
					"remark": this.remark,
					"user_info": {
						"user_id": this.userInfo._id,
						"nick_name": this.userInfo.basic_info.nick_name,
						"user_mobile": this.userInfo.basic_info.user_mobile,
					},
					"sales_list": sales_list,
					"pets_info": pets_info,
					"order_item_list": order_item_list
				}
				console.log(params)
				let loading = this.$loading();
				this.$http.post('/api/Order/CreateOrderRecharge', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.order = res.data;
						this.dialogSettlementState = true;
					}
				})
			},
			// 结算
			dialogSettlementSubmit(a){
				this.dialogSettlementState = false;
				if(a=='cancel'){
					console.log(a)
				}else if(a=='fail'){
					this.$message({
						message: '结算失败',
						type: 'error'
					});
				}else if(a=='success'){
					this.$message({
						message: '结算成功',
						type: 'success'
					});
				}
				this.reset();
			},
		}
	}
</script>
<style scoped lang="scss">
.page{
	background-color: #fff;
	.pageTitleBox{
		margin:0;
		padding-top:10px;
		
	}
	.searchBox{
		.el-form-item{
			margin-bottom:0;
		}
	}
	.msg{
		display: flex;
		flex-wrap: wrap;
		padding:0 30px;
		background-color: #fff;
		.msgItem{
			width:280px;
			font-size: 16px;
			color:#1A1A1A;
			display: flex;
			line-height: 50px;;
			.msgLabel{
				width:120px;
				text-align: right;
				color:#999999;
			}
			.msgValue{
				
			}
		}
	}
	.pageConBox{
		padding:0 20px;
		min-height: 600px;
	}
}
</style>
